module.exports = __webpack_public_path__ + "static/1-f22887336fac8012fccaa82711700583.png";